import { Box, Typography, useMediaQuery } from "@mui/material";
import { TestAdminHost } from "../../../utils/constant/stringConstant";
import { useTranslation } from "react-i18next";
import { messages } from "../../../locales/messages";

const mobileSx = {
  position: "sticky",
  bottom: "0",
  left: "0",
  width: "100%",
  textAlign: "center",
  backgroundColor: "#fff3e0",
  padding: "10px 15px",
  borderTop: "2px solid #f3c49d",
  borderRadius: "0",
  boxShadow: "none",
  zIndex: 99999,
};

const desktopSx = {
  position: "fixed",
  top: "10px",
  left: "50%",
  transform: "translateX(-50%)",
  width: "fit-content",
  textAlign: "center",
  backgroundColor: "#fff3e0",
  padding: "10px 15px",
  borderBottom: "2px solid #f3c49d",
  borderRadius: "8px",
  boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.1)",
  zIndex: 99999,
};

const TestEnvBanner = () => {
  const { t } = useTranslation();
  const isSmallScreen = useMediaQuery("(max-width:918px)");
  const shouldHide = window.location.host !== TestAdminHost;

  if (shouldHide) {
    return <></>;
  }
  return (
    <Box sx={isSmallScreen ? mobileSx : desktopSx}>
      <Typography
        variant="body2"
        sx={{
          fontSize: "14px",
          fontWeight: "bold",
          color: "#f38321",
        }}
      >
        {t(messages.TEST_ENVIRONMENT_CHANGES_HERE_WONT_AFFECT_WWW_GOFLYER_CA())}
      </Typography>
    </Box>
  );
};

export default TestEnvBanner;
